document.addEventListener('DOMContentLoaded', () => {
  const faqTitles = document.querySelectorAll('.js-faq-section-title');
  const tocContainer = document.querySelector('.js-get-faq-table-of-contents');

  if (!faqTitles.length || !tocContainer) return;

  const ul = document.createElement('ul');

  faqTitles.forEach((title, index) => {
    if (!title.id) {
      title.id = `faq-section-${index + 1}`;
    }

    const li = document.createElement('li');
    const h4 = document.createElement('h4');
    const a = document.createElement('a');

    a.textContent = title.textContent.trim();
    a.href = `#${title.id}`;

    h4.appendChild(a);
    li.appendChild(h4);
    ul.appendChild(li);
  });

  tocContainer.innerHTML = '';
  tocContainer.appendChild(ul);
});

document.addEventListener('DOMContentLoaded', () => {
  const toc = document.querySelector('.js-get-faq-table-of-contents');
  if (!toc) return;

  const links = toc.querySelectorAll('a[href^="#"]');
  const sections = [];

  const baseOffset = parseInt(toc.getAttribute('data-offset'), 10) || 70;

  links.forEach(link => {
    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    const id = href.slice(1);
    const section = document.getElementById(id);
    if (section) sections.push({ id, section });

    link.addEventListener('click', (e) => {
      e.preventDefault();

      const target = document.getElementById(id);
      if (!target) return;

      const rect = target.getBoundingClientRect();
      const scrollTop = window.scrollY || window.pageYOffset;

      const targetY = scrollTop + rect.top - baseOffset;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    });
  });

  if (!sections.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const link = toc.querySelector(`a[href="#${entry.target.id}"]`);
      if (entry.isIntersecting) {
        toc.querySelectorAll('a').forEach(a => a.classList.remove('active'));
        if (link) link.classList.add('active');
        
        if (window.innerWidth < 992) {
          link.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest'
          });
        }
      }
    });
  }, {
    root: null,
    rootMargin: '-40% 0px -60% 0px',
    threshold: 0
  });

  sections.forEach(({ section }) => observer.observe(section));
});

document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 300;

  const toggleAccordion = (toggle) => {
    const parent = toggle.closest('.js-accordion-item') || toggle.parentElement;
    if (!parent) return;

    parent.classList.toggle('active');

    const content = parent.querySelector('.js-accordion-content');
    if (!content || content.dataset.animating === 'true') return;

    const isOpen = content.classList.contains('is-open');
    content.dataset.animating = 'true';

    if (isOpen) {
      const startHeight = content.scrollHeight;
      content.style.height = startHeight + 'px';
      content.offsetHeight;
      content.style.transition = `height ${DURATION}ms ease`;
      content.style.height = '0px';

      setTimeout(() => {
        content.style.display = 'none';
        content.style.height = '';
        content.classList.remove('is-open');
        content.dataset.animating = 'false';
      }, DURATION);
    } else {
      content.style.display = 'block';
      const targetHeight = content.scrollHeight;

      content.style.height = '0px';
      content.offsetHeight;
      content.style.transition = `height ${DURATION}ms ease`;
      content.style.height = targetHeight + 'px';

      setTimeout(() => {
        content.style.height = '';
        content.classList.add('is-open');
        content.dataset.animating = 'false';
      }, DURATION);
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.js-toggle-accordion');
    if (toggle) toggleAccordion(toggle);
  });

  document.addEventListener('keydown', (event) => {
    const toggle = event.target.closest('.js-toggle-accordion');
    if (!toggle) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); 
      toggleAccordion(toggle);
    }
  });
});